import { Autocomplete, Box, Button, CircularProgress, Icon, MenuItem, Paper, Select, TextField, useTheme } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { FazendaService } from '../../services/api/FazendaService';
import { AutoCompleteColhedor1 } from '../../forms/AutoCompleteColhedor1';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { Environment } from '../../environment';

interface IDadosSelect {
  nameBD: string;
  descricao: string;
}

type TAutoCompleteOption = {
  codfaz: number;
  label: string;
}

interface IFerramentasDaListagemProps {
  dadosSelecao?: IDadosSelect[];
  dataInicial?: string;
  dataFinal?: string;
  textonome?: string;
  QtdTotal?: number;
  VlrTotal?: number;
  mostrarInputFazenda?: boolean;
  mostrarInputBasicSelect?: boolean
  textoDoSelect?: string;
  mostrarAutoComplete?: boolean;
  textoDaBusca?: string;
  mostrarInputBusca?: boolean;
  aoMudarDataInicial?: (novoTexto: string) => void;
  aoMudarDataFinal?: (novoTexto: string) => void;
  aoMudarFazenda?: (novoTexto: number) => void;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
  aoMudarTextoDoColhedor?: (novoTextoselect: string, texto1: string) => void;
  aoMudarTextoDeBusca?: (novoTexto: string) => void;
}
export const FerramentasDaListagemColheitas: React.FC<IFerramentasDaListagemProps> = ({
  dataInicial = '',
  dataFinal = '',
  textonome = '',
  textoDoSelect = '',
  textoDaBusca = '',
  QtdTotal = 0,
  VlrTotal = 0,
  aoMudarDataInicial,
  aoMudarDataFinal,
  aoMudarFazenda,
  aoMudarTextoDoSelect,
  aoMudarTextoDoColhedor,
  aoMudarTextoDeBusca,
  dadosSelecao = [],
  mostrarInputFazenda = false,
  mostrarInputBasicSelect = false,
  mostrarAutoComplete = false,
  mostrarInputBusca = false,
}) => {
  const theme = useTheme();
  const [selectedId, setSelectedId] = useState<number | undefined>();
  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');

  const partesDaDataInicial = dataInicial.split('/');
  const dataInicialFormatada = partesDaDataInicial[2] + '-' + partesDaDataInicial[1] + '-' + partesDaDataInicial[0];

  const partesDaDataFinal = dataFinal.split('/');
  const dataFinalFormatada = partesDaDataFinal[2] + '-' + partesDaDataFinal[1] + '-' + partesDaDataFinal[0];

  const handleuuidColhedorNome = (nome: string | undefined) => {
    if (nome != null) {
      textonome = nome;
    }
  };

  const handleuuidColhedor = (uuid: string | undefined) => {
    if (uuid != null) {
      aoMudarTextoDoColhedor?.(uuid, textonome);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    FazendaService.getAlllist(busca)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
        } else {
          setOpcoes(result.data.map(fazenda => ({ codfaz: fazenda.codfaz, label: fazenda.nome })));
        }
      });
  }, [busca, selectedId]);


  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.codfaz === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);

  return (
    <Box
      gap={1}
      marginX={1}
      paddingX={2}
      display="flex"
      alignItems="center"
      height={theme.spacing(5)}
      component={Paper}
      sx={{ height: '60px' }}
    >
      {mostrarInputBasicSelect && (
        <Select
          size="small" sx={{ minWidth: 150 }}
          value={textoDoSelect}
          onChange={(event) => aoMudarTextoDoSelect?.(event.target.value)}
        >
          {dadosSelecao.map((item) => (
            <MenuItem key={item.nameBD} value={item.nameBD}>
              {item.descricao}
            </MenuItem>
          ))}
        </Select>
      )}
      {mostrarInputFazenda && (
        <Autocomplete
          sx={{ minWidth: 250 }}
          openText='Abrir'
          closeText='Fechar'
          noOptionsText='Sem opções'
          loadingText='Carregando...'

          disablePortal

          options={opcoes}
          loading={isLoading}
          value={autoCompleteSelectedOption}
          onInputChange={(_, newValue) => setBusca(newValue)}
          onChange={(_, newValue) => { setSelectedId(newValue?.codfaz); aoMudarFazenda?.(newValue?.codfaz || 0); setBusca(''); }}
          popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Fazenda"
            />
          )}
        />
      )}


      {mostrarAutoComplete && (
        <Box sx={{ minWidth: 350 }} >
          <AutoCompleteColhedor1
            nome={handleuuidColhedorNome}
            idcolhedor={handleuuidColhedor}
            isExternalLoading={false}
          />
        </Box>
      )}

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          sx={{ minWidth: 150, maxWidth: 150, }}
          label="Data Inicial"
          format='DD/MM/YYYY'
          defaultValue={dayjs()}
          value={dayjs(dataInicialFormatada)}
          onChange={(date: Dayjs | null) => {
            const novoTexto = date ? date.format('DD/MM/YYYY') : '';
            aoMudarDataInicial?.(novoTexto);
          }}
          slotProps={{
            textField: {
              size: 'small',
            }
          }}
        />

        <DatePicker
          sx={{ minWidth: 150, maxWidth: 150 }}
          label="Data Final"
          format='DD/MM/YYYY'
          defaultValue={dayjs()}
          value={dayjs(dataFinalFormatada)}
          onChange={(date: Dayjs | null) => {
            const novoTexto = date ? date.format('DD/MM/YYYY') : '';
            aoMudarDataFinal?.(novoTexto);
          }}
          slotProps={{
            textField: {
              size: 'small',
            }
          }}
        />
      </LocalizationProvider>

      {mostrarInputBusca && (
        <TextField
          size="small"
          value={textoDaBusca}
          placeholder={Environment.INPUT_DE_BUSCA}
          onChange={(e) => aoMudarTextoDeBusca?.(e.target.value)}
        />
      )}
      <Box flex={1} display="flex" justifyContent="end">
        <TextField
          size="small"
          value={Number(QtdTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}
          label='Quantidade Total'
        />
        <TextField
          sx={{marginLeft:2}}
          size="small"
          value={Number(VlrTotal).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2})}
          label='Valor Total'
        />
      </Box>
    </Box>
  );
};